import { ValidationComposite } from '@/main/composites';
import { ValidationBuilder as Builder } from '@/main/builders';
export const makeTransferFundsModalValidation = () => {
    return ValidationComposite.build([
        ...Builder.field('accountFrom').required().build(),
        ...Builder.field('accountTo').required().build(),
        ...Builder.field('amount').required().numberMinMax(0, 99999999).build()
    ]);
};
export const makeModalUpdateSavingValidation = () => {
    return ValidationComposite.build([
        ...Builder.field('savingName').required().min(3).build(),
        ...Builder.field('goal').required().numberMinMax(0, 99999999).build()
    ]);
};
